import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getCategoryHeirarchy } from '../../../redux/getCategoryHeirarchy';
import NestedUserHeader from '../../../component/reusable/NestedUserHeader';
import AddCustomerForm from '../../../component/allCustomers/AddCustomerForm';
import EditCustomerForm from '../../../component/allCustomers/EditCustomerForm';
import { getAllAdminThunk } from '../../../redux/admin/adminSlice';
import { getCustomerDetailsThunk } from '../../../redux/customer/customerSlice';
import { useParams } from 'react-router-dom';

const EditCustomer = () => {

  const dispatch = useDispatch();
    const { id } = useParams()
  


  useEffect(() => {
    dispatch(getCustomerDetailsThunk(id))
    dispatch(getAllAdminThunk())
  }, [])
 

  return (
    <div >
      <NestedUserHeader
        index="Edit Customer"
        root="Dashboard"
        buttonText={'Back to list'} />
      <EditCustomerForm />
    </div>
  );

};

export default EditCustomer;
